<template>
  <div>
    <h3>Ma courbe de poids :</h3>
    <line-chart :chart-data="block.config.graphData" :options="block.config.options"></line-chart>
  </div>
</template>

<script>
  import IriadeBlockMixin from '../IriadeBlockMixin'
  import LineChart from "../../../charts/LineChart";

  export default {
    components: {LineChart},
    mixins: [IriadeBlockMixin]
  }
</script>
